import React from 'react';
import { Lightbulb, AlertTriangle, CheckCircle, Info } from 'lucide-react';
import { cn } from '../../lib/utils';

const variants = {
  tip: {
    icon: Lightbulb,
    bgClass: 'tip-box',
    iconBg: 'bg-secondary',
    iconColor: 'text-secondary-900',
  },
  warning: {
    icon: AlertTriangle,
    bgClass: 'warning-box',
    iconBg: 'bg-error',
    iconColor: 'text-white',
  },
  success: {
    icon: CheckCircle,
    bgClass: 'success-box',
    iconBg: 'bg-success',
    iconColor: 'text-white',
  },
  info: {
    icon: Info,
    bgClass: 'info-box',
    iconBg: 'bg-info',
    iconColor: 'text-white',
  },
};

const mascotImages = {
  koala: 'https://customer-assets.emergentagent.com/job_aussiesafety/artifacts/zvlucxei_BTA_Mascot.png',
  kangaroo: 'https://customer-assets.emergentagent.com/job_aussiesafety/artifacts/zvlucxei_BTA_Mascot.png',
};

export function TipBox({ variant = 'tip', mascot, title, children }) {
  const config = variants[variant];
  const Icon = config.icon;

  return (
    <div 
      className={cn(
        "rounded-2xl p-6 md:p-8",
        config.bgClass
      )}
      data-testid={`tip-box-${variant}`}
    >
      <div className="flex flex-col md:flex-row gap-4">
        {mascot && mascotImages[mascot] && (
          <div className="flex-shrink-0">
            <img
              src={mascotImages[mascot]}
              alt="BTA Buddy mascot"
              className="mascot-image w-20 h-20 object-cover"
            />
          </div>
        )}
        
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-3">
            <div className={cn(
              "w-10 h-10 rounded-xl flex items-center justify-center",
              config.iconBg
            )}>
              <Icon className={cn("w-5 h-5", config.iconColor)} />
            </div>
            <h4 className="font-heading font-bold text-lg text-text">
              {title || (variant === 'tip' ? "BTA Buddy's Tip" : variant === 'warning' ? 'Important' : 'Good to Know')}
            </h4>
          </div>
          <div className="text-text-muted leading-relaxed">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
